/**
 * Cihaz tespiti. Uygulama yalnızca PWA olarak dağıtılır; "Cihazıma kur" ekranı cihaza uygun
 * kurulum yolunu gösterir (PDF §02 kurulum deneyimi).
 */

export type InstallTarget = 'android' | 'ios-safari' | 'ios-other' | 'mac-safari' | 'desktop' | 'unsupported';

export function detectInstallTarget(ua = navigator.userAgent): InstallTarget {
  const iPadOS = /macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
  if (/iphone|ipad|ipod/i.test(ua) || iPadOS) {
    // iOS'ta ana ekrana ekleme Safari'de garanti; diğer tarayıcılar sürüme bağlı
    return /crios|fxios|edgios|opios/i.test(ua) ? 'ios-other' : 'ios-safari';
  }
  if (/android/i.test(ua)) return 'android';
  if (/macintosh/i.test(ua) && /safari/i.test(ua) && !/chrome|chromium|edg\//i.test(ua)) return 'mac-safari';
  if (/windows|macintosh|linux|cros/i.test(ua)) return 'desktop';
  return 'unsupported';
}

/** Uygulama kurulu olarak (ana ekran / masaüstü penceresi) mı açıldı? */
export function isStandalone(): boolean {
  return window.matchMedia?.('(display-mode: standalone)').matches
    || window.matchMedia?.('(display-mode: minimal-ui)').matches
    || (navigator as { standalone?: boolean }).standalone === true;
}
